import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { IntlProvider } from 'react-intl';
import messages_en from './translations/en.json';
import messages_th from './translations/th.json';
import messages_vi from './translations/vi.json';
import messages_zh from './translations/zh.json';

const messages = {
  'en': messages_en,
  'th': messages_th,
  'vi': messages_vi,
  'zh': messages_zh
};

const locale = localStorage.getItem('locale') || 'th';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <IntlProvider locale={locale} messages={messages[locale]}>
      <App />
    </IntlProvider>
  </React.StrictMode>
);
reportWebVitals();
